import { Component, OnInit } from '@angular/core';
import { DocumentType } from '../../models/documentType.model';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { DocumentService } from '../services/document.service';
import { Document } from '../models/Document';
import { DocumentAttribute } from '../models/DocumentAttribute';
import { DocumentTypeAttribute } from '../../models/documentTypeAttribute.model';
import { MatListItem } from '@angular/material/list';
import {IFileStoreItem} from '../interfaces/IFileStoreItem';
import { DocumentTypeService } from '../../services/document-type.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Url } from 'url';
import { GapiServiceService } from '../../services/gapi-service.service';
import { UserService } from '../../services/user.service';
import { CurrentUser } from '../../models/currentUser.model';
import { StorageType } from '../enums/storageType';
import { EditForm } from '../../base/controlers/edit-form';
import { TranslateService } from '@ngx-translate/core';
import { Location, DatePipe } from '@angular/common';
import { AfterNew, AfterDataLoad, AfterFormPopulated, SubmitExceptions } from '../../interfaces/iedit-form';
import { MatDialog, MatDialogConfig, MatSelectChange, MatSnackBar } from '@angular/material';
import { FileUploadService } from '../../directives/file-drop/file-upload.service';
import { FileStoreItem } from '../models/FileStoreItem';
import { throwError } from 'rxjs';
import { AttributeDisplayInfo } from '../models/attribute-display-info';
import { distinctUntilChanged } from 'rxjs/operators';
import { AttributeValidator, DynamicAttributeValidator, DynamicAttributeValidator1, getAttributeError } from '../validators/attribute-validator';
import { SubmitErrorComponent } from '../../dialogs/submit/submit-error/submit-error.component';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']
})
export class DocumentComponent extends EditForm<Document> implements OnInit, AfterNew<Document>, AfterDataLoad, AfterFormPopulated, SubmitExceptions {


  private typeId: string; 
  public isPostbackUpdating = false; 
  type: DocumentType = new DocumentType();
  public document: Document = null;
  isEdit = false;
  public documentUrl: SafeResourceUrl;
  public lastChange: Date = null;
  public lastChangeUserName: Date = null;
  storageType: string;
  public activeFileIndex = 0;
  private documentService: DocumentService;
  public hasPreview = false;
  public thumbnail: string = null;
  public dropMessage: string = null;
  public fileUploadedMessage: string = null;
  public numberOfComments = 0;

  constructor(
    ns: ToastrService,
    tr: TranslateService,
    r: Router,
    ar: ActivatedRoute,
    l: Location,
    ds: DocumentService,
    private documentTypeService: DocumentTypeService,
    private gapiService: GapiServiceService,
    private userService: UserService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
    super(ns, tr, r, ds, ar, l, '/documents');
    this.setNavigationParameters({reload: true});
    this.documentService = ds;
    this.documentUrl = null;
   }

  public get NumberOfFiles(): number {
    let ret = 0;
    const files = <FormArray>this.form.get('files');
    if (files) {
      ret = files.length;
    }
    return ret;
  }
  ngOnInit() {
    this.typeId = this.activatedRoute.snapshot.params['typeId'];
    this.setNewParameters({
      typeId: this.typeId
    });
    this.form = new FormGroup({
      id: new FormControl(),
      typeId: new FormControl(null, [Validators.required]),
      type: new FormControl(),
      name: new FormControl(null, [Validators.required]),
      description: new FormControl(null),
      lastChange: new FormControl(),
      lastChangeBy: new FormControl(),
      lastChangeUserName: new FormControl(),
      files: new FormArray([]),
      attributes: new FormArray([])
    });
    this.userService.currentUser().subscribe((user: CurrentUser) => {
      this.storageType = user.storageType;
      if (this.storageType === StorageType.Google && !this.gapiService.isSignedIn) {
        this.SignInToDrive();
      }
    });
    const messsages = this.translate.instant(['dws.dropHere', 'dws.uploadDone']);
    this.dropMessage = messsages['dws.dropHere'];
    this.fileUploadedMessage = messsages['dws.uploadDone'];
    super.ngOnInit();
  }
  getAttributeElement(index: number): FormGroup {
    const array = <FormArray>this.form.get('attributes');
    return (<FormGroup>array.at(index));
  }
  clearValue(evt: MouseEvent, index: number) {
    const array = <FormArray>this.form.get('attributes');
    const control = (<FormGroup>array.at(index));
    if (control) {
      const value = control.get('value');
      if (!value.disabled) {
        value.setValue(null);
      }      
    }
    evt.stopPropagation();
  }
  initDocument() {
    const files = <FormArray>this.form.get('files');
    if (files && files.at(this.activeFileIndex)) {
      const activeFile = files.at(this.activeFileIndex).value;
      if (activeFile) {
        this.initAttachment(activeFile);
      }
    }
  }
  getAttributeError(type: string, id: string): string {
    return getAttributeError(type, id);
  }
  initAttachment(file: IFileStoreItem): void {
    this.hasPreview = this.documentService.hasPreview(file);
    this.thumbnail = this.documentService.getThumbnail(file);
  }
  onAfterFormPopulated() {
    if (this.typeId) {
      this.documentTypeService.Get(this.typeId)
      .subscribe((type) => {
        this.type = type.payload;
      });
      const lastChange = this.form.controls['lastChange'].value;
      if (lastChange) {
        this.lastChange =  new Date(lastChange);
      }
      this.lastChangeUserName = this.form.controls['lastChangeUserName'].value;


      this.RefreshStandardAttributes();
      this.RefreshAttributes();

    }
    this.RefreshFiles();
  }
  onSubmitExceptions(response: any): void {
    if(response){
      this.isLoading = false;
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        title: 'dialogs.errors',
        type: 'document',
        messages: response
      };
      this.dialog.open(SubmitErrorComponent, dialogConfig);    
    }
  }
  SetStandardAttributeOptions(id: string, controlName: string) {        
    const attributeInfo = this.getDisplayInfo(id);
    const control = this.form.get(controlName);
    this.SetAttributeOptions(control, attributeInfo, id);
  }
  RefreshStandardAttributes() {
    this.SetStandardAttributeOptions('name', 'name');
    this.SetStandardAttributeOptions('description', 'description');
  }
  private SetAttributeOptions(control: AbstractControl, options: AttributeDisplayInfo, attributeId: string, updateValidity = false) {
    if(options) {
      control.clearValidators();
      if (options.readOnly) {
        control.disable();
      }
      else {
        control.enable();
      }
      if (options.mandatory) {
        control.setValidators([Validators.required]);
      }
      else {
        control.clearValidators();        
      }      
      if (options.hidden) {
      }
      else {
      }
      if (updateValidity) {
        control.updateValueAndValidity();
      }

      if (options.postback) {
        control.valueChanges.pipe(distinctUntilChanged()).subscribe(value => {          
          if (!this.isPostbackUpdating) {
            this.isPostbackUpdating = true;
            setTimeout(() => {
                this.onPostback('postback', attributeId).subscribe(resp => {
                  if (resp) {
                    if (resp.payload) {
                      this.SetStandardAttributeValue('name', resp.payload.name);
                      this.SetStandardAttributeValue('description', resp.payload.description);
                      this.currentData.errors = resp.payload.errors;
                      if (resp.payload.attributes) {
                        resp.payload.attributes.forEach(attr => {                          
                          let error = null;
                          if (resp.payload.errors) {
                            error = resp.payload.errors[attr.attributeId];
                          }                          
                          if (attr) {
                            this.SetAttributeValue(attr.attributeId, attr.value, error,attr.displayValue);
                          }
                        })
                      }
                    }
                  }
                  this.isPostbackUpdating = false;
                }, () => {
                  this.isPostbackUpdating = false;
                });
            }, 500);
          }
        });
      }
    }
  }
  GetAttributeIndex(id: string): number {
    let ret = -2;
    if(this.currentData && this.currentData.attributes) {
      ret = this.currentData.attributes.findIndex(f => f.attributeId === id);
    }
    return ret;
  }
  SetAttributeValue(id: string, value: any, error? :string, displayValue?:string) {
    const idx = this.GetAttributeIndex(id);
    if (idx > -1) {
      const group: FormGroup = this.getAttributeElement(idx);
      if (group) {
        const control = group.get('value');
        const displayValueControl = group.get('displayValue');
        const errorControl = group.get('error');
        if (control) {
          control.setValue(value);
          errorControl.setValue(error);
          if(displayValueControl){
            if(!displayValue){
              displayValue = null;
            }
            displayValueControl.setValue(displayValue);
          }

          setTimeout(() => {
            control.updateValueAndValidity();
          })          
        }
      }
    }
  }
  SetStandardAttributeValue(name: string, value: any) {
    const control = this.form.get(name);
    control.setValue(value);    
  }
  RefreshAttributes() {    
    let currentAttributes: any[] = null;
    let attributes: any[] = null;
    if (this.form.get('attributes')) {
      currentAttributes = this.currentData.attributes;
      attributes = Object.assign({}, currentAttributes);
    }
    this.form.get('attributes').reset();
    const formAttributes: FormArray = new FormArray([]);
    if (this.type && this.type.attributes) {
      let i = 0;
      for (const attr of this.type.attributes) {
        const currentValue = currentAttributes.filter(f => f.attributeId === attr.id);
        let attValue = null;
        let attCode = null;
        let attName = null;
        let attDisplayValue = null;
        if (currentValue && currentValue.length > 0) {          
          attValue = currentValue[0].value;
          attDisplayValue = currentValue[0].displayValue;
          attCode = attr.systemCode;
          attName = currentValue[0].name;
        }
        const valueControl = new FormControl(attValue || null);
        const codeControl = new FormControl(attCode || null);
        const nameControl = new FormControl(attName || null);
        const displayValueControl = new FormControl(attDisplayValue || null);
        // if ( this.currentData.attributeInfos && this.currentData.attributeInfos[attr.id].mandatory ) {
        //   valueControl.setValidators(Validators.required);
        // }

        const groupObject = {
          typeId: new FormControl(attr.typeId),
          typeCode: new FormControl(attr.code),
          attributeId: new FormControl(attr.id),
          error: new FormControl(null),
          value: valueControl,
          name: nameControl,
          code: codeControl,
          displayValue: displayValueControl
        };
        const formGroup = new FormGroup(groupObject);
        formGroup.setValidators(DynamicAttributeValidator);
        if (  this.currentData.attributeInfos && this.currentData.attributeInfos[attr.id]) {
          this.SetAttributeOptions(formGroup.get('value'), this.currentData.attributeInfos[attr.id], attr.id);
        }
        formAttributes.push(formGroup);
        i++;
      }
    }
    this.form.setControl('attributes', formAttributes);
  }
  private fileToFormControl(file: IFileStoreItem): any {
    return {
      container: new FormControl(file.container),
      contentType: new FormControl(file.contentType),
      date: new FormControl(file.date),
      id: new FormControl(file.id),
      link: new FormControl(file.link),
      name: new FormControl(file.name),
      descriptione: new FormControl(file.description),
      partition: new FormControl(file.partition),
      size: new FormControl(file.size)
    };
  }
  private getDisplayInfo(id: string): AttributeDisplayInfo {
    const ret = this.currentData.attributeInfos[id];
    if (!ret) {
      console.error(`attribute options for id:${id} not found`);
    }
    return ret;
  }
  RefreshFiles() {
    let currentFiles: IFileStoreItem[] = null;
    let files: any[] = null;
    if (this.currentData.files) {
      currentFiles = this.currentData.files;
      files = Object.assign({}, currentFiles);
    }
    this.form.get('files').reset();
    const formFiles: FormArray = new FormArray([]);
    if (currentFiles) {
      let i = 0;
      for (const file of currentFiles) {

        const groupObject = this.fileToFormControl(file);
        const formGroup = new FormGroup(groupObject);
        formFiles.push(formGroup);
        i++;
      }
    }
    this.form.setControl('files', formFiles);
    this.initDocument();
  }
  ClearAttributes() {
    this.form.get('attributes').reset();
  }


  GetAttribute(id: string): DocumentTypeAttribute {
    let ret: DocumentTypeAttribute = null;

    if (!id || !this.type || !this.type.attributes) {
      return ret;
    }
    this.type.attributes.forEach((attribute) => {
      if (attribute.typeId === id) {
        ret = attribute;
      }
    });

    return ret;
  }

  GetInputAttribute(id: string): DocumentAttribute {
    let ret: DocumentAttribute = null;

    if (!id || !this.form) {
      return ret;
    }
    const attriutes = <FormArray>this.form.controls['attributes'];
    if (attriutes) {
      for (const control of attriutes.controls) {
        if (control.value.typeId === id) {
          ret = control.value;
        }
      }
    }
    return ret;
  }

  OnUpload(fileInfo: IFileStoreItem, fileIndex: number) {
    if (fileInfo) {
      const files = <FormArray>this.form.get('files');
      files.at(fileIndex).patchValue(fileInfo);
      this.initAttachment(fileInfo);
      this._snackBar.open(this.fileUploadedMessage, null, {
        duration: 2000,
      });
    }
  }

  private newFile() {
    return {
      container: new FormControl(),
      contentType: new FormControl(),
      date: new FormControl(),
      id: new FormControl(),
      link: new FormControl(),
      name: new FormControl(),
      description: new FormControl(),
      partition: new FormControl(),
      size: new FormControl()
    };
  }
  onAddFile() {
    const files = <FormArray>this.form.get('files');

    files.insert(0, new FormGroup(this.newFile()));
    this.activeFileIndex = 0;
    this.initDocument();
  }
  OnTypeSelected(e) {
    if (e) {
      this.type = e;
    } else {
      this.type = null;
    }
    if (this.type && this.type.attributes) {
      this.form.controls['typeId'].setValue(this.type.id);
      this.form.controls['type'].setValue(this.type.name);
      this.RefreshStandardAttributes();
      this.RefreshAttributes();
    } else {
      this.ClearAttributes();
    }
  }
  public showObject() {
  }
  public OnCancel() {
    this.router.navigate(['/documents']);
   }

  public SignInToDrive() {
    if (!this.gapiService.isGoogle) {
      return;
    }
    this.gapiService.signIn().then(() => {
      this.gapiService.initRootFolder();
  });
  }

  public NewDocument() {
    this.form.controls['file'].setValue(null);
  }
  onAterNew(model: Document): Document {
    this.activatedRoute.queryParams.subscribe(params => {
      const typeId = params['typeId'];
      if (typeId) {
        setInterval(() => {
          this.form.controls['typeId'].setValue(typeId);
        }, 300);
      }
      if (model.files === null || model.files.length === 0) {
        model.files = [
          {
            id: null,
            name: null,
            description: null,
            container: null,
            partition: null,
            contentType: null,
            size: null,
            link: null,
            date: new Date()
          }
        ];
      }
    });
    return model;
  }
  onPrevFile() {
    this.activeFileIndex--;
    this.initDocument();
  }
  onNextFile() {
    this.activeFileIndex++;
    this.initDocument();
  }
  changeActiveFile(selected: MatSelectChange) {
    this.activeFileIndex = selected.value;
  }
  onDeleteFile() {
    let index = null;
    const files = <FormArray>this.form.get('files');
    if (files.length === 1) {
      index = 0;
    } else if (this.activeFileIndex > 0) {
      index = this.activeFileIndex - 1;
    }
    if (index !== null) {
      if (files.length === 1) {
        files.at(this.activeFileIndex).patchValue(FileStoreItem.empty);
      } else {
        files.removeAt(this.activeFileIndex);
        this.activeFileIndex = index;
      }
      this.initDocument();
    }
  }
  onNumberOfCommentsChanged(count: number) {
    this.numberOfComments = count;
  }
  onTest() {
  }
  public get documentDocumentLink() {
    const id = this.id;
    return id ? this.documentService.GetDownloadLink(id) : null;
  }  
}
